/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { SerializedLegacyNewsletterRecipientFilter } from 'cio/types/conditions/legacy-filter';
import CampaignModel from 'cio/models/campaign';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import { ConditionViewerBackgroundVariant } from 'cio/utils/condition-viewer';
import { task } from 'ember-concurrency';
import NewsletterModel from 'cio/models/newsletter';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

interface CioConditionLabelItemNewsletterArgs {
  condition: SerializedLegacyNewsletterRecipientFilter;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
  campaign?: CampaignModel;
  tagName: string;
  backgroundVariant?: ConditionViewerBackgroundVariant;
}

export default class CioConditionLabelItemNewsletter extends Component<CioConditionLabelItemNewsletterArgs> {
  @service store!: DS.Store;

  @tracked newsletter: NewsletterModel | null = null;
  previousNewsletterId: string | null = null;

  constructor(owner: unknown, args: CioConditionLabelItemNewsletterArgs) {
    super(owner, args);

    this.loadNewsletter.perform();
  }

  get isLoading() {
    return this.newsletter == null && this.loadNewsletter.isRunning;
  }

  loadNewsletter = task({ restartable: true }, async () => {
    let id = this.args.condition?.newsletter_id;

    if (id == null) {
      this.newsletter = null;
      return;
    }

    let newsletter = this.store.peekRecord('newsletter', id);

    if (newsletter != null) {
      this.newsletter = newsletter;
      await newsletter.reload();
    } else {
      this.newsletter = await this.store.findRecord('newsletter', id);
    }

    this.previousNewsletterId = String(id);
  });

  @action
  reloadNewsletterIfChanged() {
    let argsId = this.args.condition?.newsletter_id;
    let id: string | null = null;

    if (argsId != null) {
      id = String(id);
    }

    if (id !== this.previousNewsletterId) {
      this.loadNewsletter.perform();
    }
  }

  get labelVariant() {
    if (this.args.labelVariant != null) {
      return this.args.labelVariant;
    }

    return this.args.backgroundVariant === ConditionViewerBackgroundVariant.Dark
      ? DataSourceLabelVariant.Light
      : DataSourceLabelVariant.Dark;
  }
}
